export class TestUser {

    public relations = ['user'];

    public names = {
        user_id: (data) => {
            if(!data.user){
                return 'нет';
            }
            return data.user.f + ' ' + data.user.i + ' '  + data.user.o;
        },
        test_id: (data) => data.test_id
    }
}
